import { create } from "zustand";
import { persist } from "zustand/middleware";
import { SUPPORTED_LANGS, STRINGS, type Lang, type StringKey, type TVars } from "./strings";

const detect = (): Lang => {
  const nav = (typeof navigator !== "undefined" ? navigator.language : "en").toLowerCase();
  return nav.startsWith("ru") ? "ru" : "en";
};

interface LangState {
  lang: Lang;
  setLang: (lang: Lang) => void;
}

export const useLangStore = create<LangState>()(
  persist(
    (set) => ({
      lang: detect(),
      setLang: (lang) => {
        if (SUPPORTED_LANGS.includes(lang)) set({ lang });
      },
    }),
    {
      name: "ss.lang",
      version: 1,
    },
  ),
);

export const translate = (lang: Lang, key: StringKey, vars: TVars = {}): string => {
  const entry = STRINGS[lang][key] ?? STRINGS.en[key];
  if (typeof entry === "function") return entry(vars);
  return entry.replace(/\{(\w+)\}/g, (_, k: string) => String(vars[k] ?? ""));
};

export const useT = (): ((key: StringKey, vars?: TVars) => string) => {
  const lang = useLangStore((s) => s.lang);
  return (key, vars) => translate(lang, key, vars);
};

export type { Lang, StringKey };
